import { TinyPetsWorld } from "../TinyPetsWorld";

export const timeSystem = (world: TinyPetsWorld) => {
    const { time } = world;
    const now = performance.now();
    const delta = now - time.then;
    time.delta = delta;
    time.elapsed += delta;
    time.then = now;
    return world;
};
